import React, { useState } from 'react';
import './Services.css';

function Services() {
  // State to control showing/hiding of Clinical Review sub-services
  const [showAllClinicalReview, setShowAllClinicalReview] = useState(false);

  // Toggle function for Clinical Review sub-services
  const toggleClinicalReview = () => {
    setShowAllClinicalReview(!showAllClinicalReview);
  };

  return (
    <section id="services-section" className="services">
      <h2>Our Services</h2>
      <div className="services-container">

        {/* Service 1 */}
        <div className="service-card">
          <img
            src="./images/coding image.jpeg"
            alt="Coding and Oasis Review"
            className="service-image"
          />
          <div className="service-content">
            <h3 className="service-title">CODING AND OASIS REVIEW SERVICES</h3>
            <p className="service-description">
              <b>Coding Services:</b> Accurate coding is crucial for proper reimbursement and regulatory compliance in home health care. Our experienced professionals deliver precise coding for diagnoses, procedures, and services, optimizing revenue while ensuring compliance with industry standards.
              <br /><br />
              <b>OASIS Review:</b> Our OASIS review services focus on ensuring comprehensive and accurate documentation. By identifying errors and omissions, we help improve data quality and patient outcomes, offering valuable insights to strengthen overall care and compliance.
            </p>
          </div>
        </div>

        {/* Service 2 */}
        <div className="service-card">
          <img
            src="./images/oasis review.webp"
            alt="POC Review Services"
            className="service-image"
          />
          <div className="service-content">
            <h3 className="service-title">POC Review Services</h3>
            <p className="service-description">
              Our Point-of-Care (POC) review services ensure precise, compliant, and thorough documentation directly at the point of care. We meticulously assess POC records for completeness, clinical accuracy, and alignment with regulatory standards. By enhancing documentation quality, we support seamless care coordination and help maximize reimbursement efficiency.
            </p>
          </div>
        </div>

        {/* Service 3 */}
        <div className="service-card">
          <img
            src="./images/clinical-review.png"
            alt="Clinical Review Services"
            className="service-image"
          />
          <div className="service-content">
            <h3 className="service-title">Clinical Review Services</h3>
            <p className="service-description">
              <b>Documentation Accuracy:</b> Ensure all recorded information accurately reflects the patient’s condition and care provided. Verify vital signs, medication dosages, and intervention timings for precision. Promptly address any discrepancies or omissions to uphold patient safety and care standards.
              <br /><br />
              <b>Completeness and Clarity:</b> Document all aspects of care, including assessments, interventions, patient responses, and outcomes. Use concise, standardized, and unambiguous language to promote clear communication and avoid misunderstandings among healthcare providers.
              <br /><br />
              {showAllClinicalReview ? (
                <>
                  <b>Timeliness and Consistency:</b> Record patient interactions immediately to ensure accuracy and relevance. Maintain consistent documentation frequency tailored to the patient’s condition and care requirements to support continuity and quality of care.
                  <br /><br />
                  <b>Objective Language:</b> Emphasize observable signs, symptoms, and measurable responses in documentation. Avoid subjective statements unless supported by evidence, preserving credibility and fostering effective communication.
                  <br /><br />
                  <b>Communication and Collaboration:</b> Demonstrate interdisciplinary teamwork by thoroughly documenting consultations, referrals, and care plan discussions. Ensure comprehensive and coordinated patient care through clear and detailed communication among all involved professionals.
                </>
              ) : (
                <button onClick={toggleClinicalReview} className="read-more-button">
                  Read More
                </button>
              )}
            </p>
          </div>
        </div>

        {/* Service 4 */}
        <div className="service-card">
          <img
            src="./images/DE.jpg"
            alt="Data Entry Services"
            className="service-image"
          />
          <div className="service-content">
            <h3 className="service-title">Data Entry Services</h3>
            <p className="service-description">
              Accurate and efficient data entry is essential for maintaining reliable, up-to-date records critical to patient care and compliance. Our expert data entry team delivers meticulous and streamlined services, ensuring all patient information, assessments, and care plans are recorded with precision. By outsourcing your data entry needs to us, you can optimize time and resources, enabling your staff to prioritize providing exceptional care and improving patient outcomes.
            </p>
          </div>
        </div>

        {/* Service 5 */}
        <div className="service-card">
          <img
            src="./images/pa.webp"
            alt="Prior Authorizations"
            className="service-image"
          />
          <div className="service-content">
            <h3 className="service-title">Prior Authorizations</h3>
            <p className="service-description">
              Navigating the complexities of prior authorization can be both time-consuming and challenging. Our comprehensive prior authorization services alleviate this burden by handling the entire process for you. Our dedicated team works closely with payers to ensure the accurate and timely submission of all necessary documentation, streamlining the approval process and minimizing administrative delays. Trust us to optimize your prior authorization workflows, allowing your team to focus on what matters most—delivering exceptional care to your patients.
            </p>
          </div>
        </div>

        {/* Service 6 */}
        <div className="service-card">
          <img
            src="./images/dm.jpg"
            alt="Digital Marketing Services"
            className="service-image"
          />
          <div className="service-content">
            <h3 className="service-title">Digital Marketing Services</h3>
            <p className="service-description">
              Our digital marketing services are designed to help you grow your online presence, reach your target audience, and drive business results. From search engine optimization (SEO) and social media marketing to pay-per-click (PPC) advertising and content creation, we offer a comprehensive suite of strategies tailored to your business goals. By leveraging data-driven insights and the latest digital tools, we ensure effective, results-oriented campaigns that enhance brand visibility, engagement, and conversions. Let us help you connect with customers and stay ahead in the competitive digital landscape.
            </p>
          </div>
        </div>
        
      </div>
    </section>
  );
}

export default Services;
